export default "__VITE_ASSET__9dc28012__"